// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3i-1";
export var rateTableServiceLevelDropdown = "_3i-3";
export var rateTableTypeDropdown = "_3i-0";
export var rateTableValueModeDropdown = "_3i-2";